const errorMessages = {
  network: "Something went wrong, please try again later",
  missingPassword: "Please input your current and new password.",
  passwordLength: "Passwords should be between 8 and 15 characters long.",
  passwordConfirmationMismatch: "New password does not match the password confirmation.",
  wrongPassword: "Your current password is incorrect."
};

export default errorMessages;